import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import ElementUI from "element-ui";
import moment from "moment";
import "element-ui/lib/theme-chalk/index.css";
import "../src/assets/sass/main.scss";
import "./RegisterPlugins";
import locale from 'element-ui/lib/locale';
import en_locale from 'element-ui/lib/locale/lang/en'
import ge_locale from "@/helpers/ge_locale";
Vue.use(require("vue-cookies"));

Vue.config.productionTip = false;

Vue.use(ElementUI, { locale });

Vue.directive("click-outside", {
  bind(el, binding, vnode) {
    el._event = ev => {
      if (!(el == ev.target || el.contains(ev.target))) {
        vnode.context[binding.expression]();
      }
    };
    document.body.addEventListener("click", el._event);
  },
  unbind(el) {
    document.body.removeEventListener("click", el._event);
  }
});

new Vue({
  router: router,
  store,
  beforeCreate: function() {
    /// if set lang identifier into url set it as site current lang

    if (
      this.$route.name &&
      _.size(this.$route.name) >= 2 &&
      this.$route.name.slice(-3, -2) === "_"
    ) {
      this.$store.commit("main/setState", {
        key: "locale",
        val: this.$route.name.slice(-2)
      });
    }

    /// set ajax default request lang
    axios.defaults.headers.common["lang"] = this.$store.state.main.locale;

    if (this.$route.query.preview)
      this.$cookies.set("siteMode", this.$route.query.preview, "1d");

    /// load site main data
    this.$store.dispatch("main/indx");
  },
  mounted() {
    window.scrollTo(0, 0);
    /*setTimeout(enable, 500)*/
  },
  watch: {
    "$route.name": {
      immediate: true,
      handler() {
        // return false;
        /// set selected locale
        /// set axios default header for selected language
        /// send main request to server

        if (!this.$route.name) return false;

        // if (this.$route.name === 'PageViewRouter_ge') {
        //   localeLang.use(geLocale)
        // } else if (this.$route.name === 'PageViewRouter_en') {
        //   localeLang.use(enLocale)
        // }



        if (this.$route.name === 'PageViewRouter_ge') {
          locale.use(ge_locale)
        } else if (this.$route.name === 'PageViewRouter_en') {
          locale.use(en_locale)
        }


        /// if set lang identifier into url set it as site current lang
        if (
          this.$route.name &&
          _.size(this.$route.name) >= 2 &&
          this.$route.name.slice(-3, -2) === "_"
        ) {
          this.$store.commit("main/setState", {
            key: "locale",
            val: this.$route.name.slice(-2)
          });
        }

        /// set ajax default request lang
        axios.defaults.headers.common["lang"] = this.$store.state.main.locale;

        this.$store.commit("main/setMenuFullUrls");

        if (this.$cookies.get("siteMode"))
          axios.defaults.headers.common["siteMode"] = this.$cookies.get(
            "siteMode"
          );

        /// load indx part after every language change
        this.$store.dispatch("main/indxTranslatable");

        /// loads only once
        this.$store.dispatch("main/getTranslations");
      }
    },
    "$store.state.main.locale": {
      immediate: true,
      handler: function(val) {
        this.$moment.locale(this.setLanguage(val));
      }
    }
  },
  methods: {
    setLanguage(lang) {
      if (lang == "ge") {
        this.$moment.locale("ka");
        return "ka";
      } else {
        return lang;
      }
    }
  },

  render: h => h(App)
}).$mount("#app");
